import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/overlay';

/**
 * Service used for manipulating with dialogs
 */
@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {
  }

  /**
   * Closes dialog with provided id
   * @param id unique identifier of dialog
   */
  close(id: string) {
    this.dialog.getDialogById(id).close();
  }

  /**
   * Opens dialog for provided component and dialog configuration
   * @param component Component that will be displayed in dialog
   * @param dialogConf Configuration for dialog
   */
  open(component: ComponentType<any>, dialogConf: MatDialogConfig = null): MatDialogRef<any> {
    return this.dialog.open(component, dialogConf);
  }

  /**
   * Closes all opened dialogs
   */
  closeAll() {
    this.dialog.closeAll();
  }
}
